module.exports = __webpack_public_path__ + "654f031ca9fb7c1856d2a096a85f946f.jpg";